import { Box } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import type { EpisodeCategory, ServiceType } from '@common/enums';
import type { IPatient } from '@common/interfaces/patient';
import type { ServiceUrlObject } from '@common/interfaces/serviceUrlObject';
import { ProcessStartWizardCard } from '@frontend/components/pages/processStartWizard/components/ProcessStartWizardCard';
import { ProcessStartWizard as NewProcessStartWizard } from '@frontend/components/pages/processStartWizard/ProcessStartWizard';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

type ProcessStartWizardProps = {
    children: React.ReactNode;
    episodeCategory?: EpisodeCategory | null;
    hasOverlay?: boolean;
    onAddProcessToEpisode?: (args: ServiceUrlObject) => Promise<void> | void;
    patient?: IPatient;
    serviceType?: ServiceType | null;
};

export function ProcessStartWizard({
    children,
    episodeCategory,
    hasOverlay,
    onAddProcessToEpisode,
    patient,
    serviceType,
}: ProcessStartWizardProps) {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();
    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(() => {
        setShowOverlay(!!hasOverlay);
    }, [hasOverlay]);

    function renderProcessStartWizard() {
        if (hasProcessStartWizardWithCards) {
            return (
                <NewProcessStartWizard
                    episodeCategory={episodeCategory}
                    onAddProcessToEpisode={onAddProcessToEpisode}
                    onShowOverlay={setShowOverlay}
                    patientId={patient?.id}
                    serviceType={serviceType}
                />
            );
        }

        return <ProcessStartWizardCard>{children}</ProcessStartWizardCard>;
    }

    return (
        <>
            <Box
                position="relative"
                zIndex={showOverlay ? 2 : 'auto'}
            >
                {renderProcessStartWizard()}
            </Box>
            {showOverlay && <StyledOverlay />}
        </>
    );
}

const StyledOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgb(244 244 244 / 80%);
    z-index: 1;
`;
